module.exports = __webpack_public_path__ + "img/15 Kirbisser Platz 2 (1).jpg";